/* Prezently — strona produktu: galeria, warianty, ilość, dodawanie do szuflady Shrine, pasek na dole,
   pasek darmowej dostawy liczony z aktualnego koszyka (pusty koszyk → cena wybranego wariantu). */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__pz) return;
    root.__pz = 1;

    /* ---------- galeria ---------- */
    var track = root.querySelector('[data-pz-track]');
    var slides = track ? track.querySelectorAll('[data-pz-slide]') : [];
    var prev = root.querySelector('[data-pz-prev]');
    var next = root.querySelector('[data-pz-next]');
    var count = root.querySelector('[data-pz-count]');
    var thumbs = root.querySelectorAll('[data-pz-thumb]');
    var biez = 0;

    function pokaz(i) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollLeft = i * track.clientWidth;   // scrollTo() bywa ignorowane — ustawiamy wprost
      ustawStan(i);
    }
    function ustawStan(i) {
      biez = i;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.toggle('is-on', k === i);
      var t = thumbs[i];
      if (t && t.parentElement) {
        var p = t.parentElement;
        var l = t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2;
        p.scrollLeft = Math.max(0, l);
      }
    }
    if (track) {
      var tik;
      track.addEventListener('scroll', function () {
        clearTimeout(tik);
        tik = setTimeout(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== biez) ustawStan(i);
        }, 60);
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { pokaz(biez - 1); });
      if (next) next.addEventListener('click', function () { pokaz(biez + 1); });
      for (var t = 0; t < thumbs.length; t++) {
        thumbs[t].addEventListener('click', function () { pokaz(parseInt(this.getAttribute('data-pz-thumb'), 10)); });
      }
      if (next) next.disabled = slides.length < 2;
    }
    function pokazMedia(id) {
      if (!id) return;
      for (var k = 0; k < slides.length; k++) {
        if (slides[k].getAttribute('data-media-id') === String(id)) { pokaz(k); return; }
      }
    }

    /* ---------- warianty ---------- */
    var dane = [];
    try { dane = JSON.parse(root.querySelector('[data-pz-v]').textContent); } catch (e) {}
    var txt = {};
    try { txt = JSON.parse(root.querySelector('[data-pz-txt]').textContent); } catch (e) {}
    var form = root.querySelector('[data-pz-form]');
    var idInput = root.querySelector('[data-pz-id]');
    var atc = root.querySelector('[data-pz-atc]');
    var atcT = root.querySelector('[data-pz-atc-t]');
    var now = root.querySelector('[data-pz-now]');
    var was = root.querySelector('[data-pz-was]');
    var off = root.querySelector('[data-pz-off]');
    var stickyP = root.querySelector('[data-pz-sticky-p]');
    var opcje = root.querySelectorAll('[data-pz-opt]');

    function wybrane() {
      var w = [];
      for (var i = 0; i < opcje.length; i++) {
        var c = opcje[i].querySelector('input:checked');
        w.push(c ? c.value : null);
      }
      return w;
    }
    function znajdz(w) {
      for (var i = 0; i < dane.length; i++) {
        var ok = true;
        for (var j = 0; j < w.length; j++) if (dane[i].opts[j] !== w[j]) { ok = false; break; }
        if (ok) return dane[i];
      }
      return null;
    }
    function oznaczNiedostepne(w) {
      // przekreśl wartości, które w połączeniu z pozostałymi wyborami nie dają dostępnego wariantu
      for (var i = 0; i < opcje.length; i++) {
        var pille = opcje[i].querySelectorAll('.pz-pill');
        for (var k = 0; k < pille.length; k++) {
          var inp = pille[k].querySelector('input');
          var test = w.slice(); test[i] = inp.value;
          var v = znajdz(test);
          pille[k].classList.toggle('is-na', !v || !v.av);
        }
      }
    }
    function zastosuj(v) {
      if (!v) {
        if (atc) atc.disabled = true;
        if (atcT) atcT.textContent = txt.soldout || 'Niedostępne';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (now) now.textContent = v.price;
      if (stickyP) stickyP.textContent = v.price;
      if (was) { was.hidden = !v.cmp; if (v.cmp) was.textContent = v.cmp; }
      if (off) { off.hidden = !v.off; off.textContent = '-' + v.off + '%'; }
      if (atc) atc.disabled = !v.av;
      if (atcT) atcT.textContent = v.av ? (txt.atc || 'Dodaj do koszyka') : (txt.soldout || 'Wyprzedane');
      if (v.media) pokazMedia(v.media);
      wariantC = v.c;
      rysujDostawe();
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }
    for (var o = 0; o < opcje.length; o++) {
      opcje[o].addEventListener('change', function (e) {
        var sel = this.querySelector('[data-pz-sel]');
        if (sel && e.target && e.target.value) sel.textContent = e.target.value;
        var w = wybrane();
        oznaczNiedostepne(w);
        zastosuj(znajdz(w));
      });
    }
    if (opcje.length) oznaczNiedostepne(wybrane());

    /* ---------- pasek darmowej dostawy: aktualny koszyk ---------- */
    var ship = root.querySelector('[data-pz-ship]');
    var shipT = root.querySelector('[data-pz-ship-t]');
    var shipBar = root.querySelector('[data-pz-ship-bar]');
    var prog = ship ? parseInt(ship.getAttribute('data-prog'), 10) || 0 : 0;
    var koszyk = ship ? parseInt(ship.getAttribute('data-cart'), 10) || 0 : 0;
    var wariantC = ship ? parseInt(ship.getAttribute('data-price'), 10) || 0 : 0;
    function zl(c) {
      return (c / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
    }
    function rysujDostawe() {
      if (!ship || !prog) return;
      var zKoszyka = koszyk > 0;
      var suma = zKoszyka ? koszyk : wariantC;
      var brak = prog - suma;
      ship.classList.toggle('is-ok', brak <= 0);
      if (shipBar) shipBar.style.width = Math.min(100, Math.round(suma / prog * 1000) / 10) + '%';
      if (shipT) {
        if (brak <= 0) shipT.innerHTML = zKoszyka ? (txt.shipCartOk || 'Masz już <b>darmową dostawę</b>') : (txt.shipOk || 'Ten prezent ma <b>darmową dostawę</b>');
        else shipT.innerHTML = (txt.shipLeft || 'Do <b>darmowej dostawy</b> brakuje') + ' ' + zl(brak);
      }
    }
    var tikK;
    function odswiezKoszyk() {
      if (!ship) return;
      clearTimeout(tikK);
      tikK = setTimeout(function () {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (c) { koszyk = c.item_count > 0 ? c.total_price : 0; rysujDostawe(); })
          .catch(function () {});
      }, 120);
    }
    if (ship) {
      document.addEventListener('pz:koszyk', odswiezKoszyk);
      window.addEventListener('pageshow', function (e) { if (e.persisted) odswiezKoszyk(); });
    }

    /* ---------- ilość ---------- */
    var qty = root.querySelector('[data-pz-qty]');
    function ustawIlosc(n) {
      if (!qty) return;
      var max = parseInt(qty.getAttribute('max'), 10) || 99;
      qty.value = Math.max(1, Math.min(max, n || 1));
    }
    var minus = root.querySelector('[data-pz-minus]');
    var plus = root.querySelector('[data-pz-plus]');
    if (minus) minus.addEventListener('click', function () { ustawIlosc(parseInt(qty.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { ustawIlosc(parseInt(qty.value, 10) + 1); });
    if (qty) qty.addEventListener('change', function () { ustawIlosc(parseInt(qty.value, 10)); });

    /* ---------- dodanie do koszyka: szuflada Shrine (API jak w Dawn) ---------- */
    var err = root.querySelector('[data-pz-err]');
    function dodaj() {
      if (!form || !atc || atc.disabled) return;
      var drawer = document.querySelector('cart-drawer');
      var fd = new FormData(form);
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
      }
      var stary = atcT ? atcT.textContent : '';
      atc.disabled = true;
      if (atcT) atcT.textContent = txt.adding || 'Dodaję…';
      if (err) err.hidden = true;
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: fd
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'blad');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = '/cart';
        }
      }).catch(function (e) {
        if (err) { err.textContent = (e && e.message && e.message !== 'blad') ? e.message : (txt.err || 'Błąd'); err.hidden = false; }
      }).then(function () {
        atc.disabled = false;
        if (atcT) atcT.textContent = stary;
      });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); dodaj(); });

    /* ---------- pasek na dole ---------- */
    var sticky = root.querySelector('[data-pz-sticky]');
    var stickyBtn = root.querySelector('[data-pz-sticky-btn]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (w) {
        var widac = w[0].isIntersecting;
        var ponizej = w[0].boundingClientRect.top < 0;
        var on = !widac && ponizej;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = on ? 0 : -1;
      });
      obs.observe(atc);
    }
    if (stickyBtn) stickyBtn.addEventListener('click', dodaj);
  }

  /* każda zmiana koszyka (dodanie, zmiana ilości w szufladzie, usunięcie) → zdarzenie pz:koszyk */
  if (!window.__pzFetchKoszyk && window.fetch) {
    window.__pzFetchKoszyk = true;
    var oryg = window.fetch;
    window.fetch = function (u) {
      var p = oryg.apply(this, arguments);
      try {
        var adres = typeof u === 'string' ? u : (u && u.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(adres)) {
          p.then(function () { document.dispatchEvent(new CustomEvent('pz:koszyk')); }, function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  function start() { document.querySelectorAll('[data-pz-pp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
